import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fb2fa69"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb2fa69')) {
      api.createRecord('1fb2fa69', component.options)
    } else {
      api.reload('1fb2fa69', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fb2fa69", function () {
      api.rerender('1fb2fa69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/type/list/index.vue"
export default component.exports